// extracted by mini-css-extract-plugin
export default {"root":"MobileFloatingCTA_root__UxOLc","instagram":"MobileFloatingCTA_instagram__8-oRL","line":"MobileFloatingCTA_line__MOMAT"};